import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, TextField } from '@mui/material';
import React, { useContext, useState } from 'react';
import { GlobalStateContext, IFilters } from '../wrappers/GlobalContext';

type Props = {
  options: Array<{ label: string, key?: string }>,
  label: string,
  filterKey: string,
  searchable?: boolean,
  overprice?: boolean, // Adicionada a prop overprice
}

function SelectSingle({ options, label, filterKey, searchable, overprice = false }: Props) { // Valor padrão definido
  const [search, setSearch] = useState<string>("");
  const { typedFilters, setTypedFilters, typedFiltersOverprice, setTypedFiltersOverprice } = useContext(GlobalStateContext);

  const handleChange = (event: SelectChangeEvent<string | number | boolean | string[]>) => {
    const {
      target: { value },
    } = event;

    const filters = overprice ? typedFiltersOverprice : typedFilters;
    const setFilters = overprice ? setTypedFiltersOverprice : setTypedFilters;

    if (["body", "body_type", "procurement_type", "modality", "object_nature"].includes(filterKey)) {
      setFilters({
        ...filters,
        [filterKey]: [value],
      });
    } else {
      setFilters({
        ...filters,
        [filterKey]: value,
      });
    }
  };

  const value = () => (overprice ? typedFiltersOverprice[filterKey as keyof IFilters] : typedFilters[filterKey as keyof IFilters]);
  const filteredOptions = () => search ? options.filter(opt => opt.label.toLowerCase().includes(search.toLowerCase())) : options;

  return (
    <FormControl className='w-full' sx={{ maxWidth: 350 }}>
      <InputLabel id={`${label}-label`}>{label}</InputLabel>
      <Select
        autoWidth
        labelId={`${label}-label`}
        id={label}
        input={<OutlinedInput label={label} />}
        value={value()}
        onChange={handleChange}
      >
        {searchable &&
          <div className='p-2'>
            <TextField
              className='w-full'
              variant='outlined'
              size='small'
              placeholder='Buscar...'
              value={search}
              type="search"
              onKeyDown={(e) => { e.stopPropagation(); }}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        }
        <MenuItem value=""> - </MenuItem>
        {filteredOptions().map((option) => (
          <MenuItem key={option.label} value={option.key || option.label}>{option.label}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SelectSingle;
